<div>
	<div
		class="d-flex justify-content-center kiosk-canvas-header"
		[style.background-color]="kioskService.venueService?.ooVenue.styles?.kioskCanvasItemHeaderBgColor"
	>
		<div class="h2">{{ canvasName }}</div>
	</div>
	<div class="">
		<p-dataView [value]="canvasMenuItems" layout="grid" styleClass="">
			<ng-template pTemplate="gridItem" let-rec>
				<div
					class="p-lg-5 p-md-5 p-col-12 h-100 mx-2 my-3 amimation-slide-in-bottom animation-duration-4s"
					style="height: 400px"
					(click)="canvasMenuItemSelectedEmitter.emit(rec)"
				>
					<div class="d-flex flex-column justify-content-center h-100 w-100">
						<div class="h3">{{ rec.displayName || rec.ooMenuItem.name }}</div>
						<div class="text-center">
							<img
								*ngIf="rec.ooMenuItem?.kioskImageKey || rec.ooMenuItem?.imageKey"
								width="auto"
								style="max-height: 200px"
								[src]="
									'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' +
									kioskService.venueService.venueKey +
									'/' +
									(rec.ooMenuItem?.kioskImageKey || rec.ooMenuItem?.imageKey)
								"
							/>
							<img
								*ngIf="!rec.ooMenuItem?.imageKey"
								width="auto"
								style="max-height: 200px"
								[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + kioskService.venueService.venueKey + '/default.png?'"
							/>
						</div>
						<div class="text-center lead mt-4">{{ rec.description || "&nbsp;" }}</div>
						<div class="text-center h2">
							{{ kioskService.venueService.menuItemGetPriceFromNumber(rec.ooMenuItem, rec.priceNumber) | currency }}
						</div>
					</div>
				</div>
			</ng-template>
		</p-dataView>
	</div>
</div>
